// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;

/*
render function
*/
import { accSearchBoxServiceRenderFunction } from 'js/accSearchBoxService';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/accSearchBoxService', () => import('js/accSearchBoxService'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "data": {},
  "actions": {
    "render": {
      "method": "accSearchBoxServiceRenderFunction",
      "options": {
        "elementRefList": ["searchBox"]
      },
      "deps": "js/accSearchBoxService"
    }
  },
  "i18n": {
    "SEARCH_LABEL_OLD": ["BaseMessages"],
    "SEARCH_LABEL": ["projectMessages"]
  },
  "lifecycleHooks": {
    "render": "render"
  },
  "props": {
    "action": {
      "type": "action"
    },
    "reset-action": {
      "type": "action"
    },
    "prop": {
      "type": "field"
    },
    "placeholder": {
      "type": "object"
    },
    "selectAction": {
      "type": "action"
    },
    "change-action": {
      "type": "action"
    },
    "click-action": {
      "type": "action"
    },
    "accsessionid": {
      "type": "string"
    },
    "ix-enabled": {
      "type": "boolean"
    }
  },
  "messages": {},
  "conditions": {},
  "_viewModelId": "AccSearchBox",
  "_uniqueViewModelId": "AccSearchBox",
  "ctx": {}
};

/*
define component
*/
const Component = createComponent(declViewModelJson, accSearchBoxServiceRenderFunction, {
  "elementRefList": ["searchBox"]
}, ctxImportObj);
export default Component;